export default {
  SET_LOADING(state, value) {
    state.loading = value;
  },

  SET_CONVERSATION_ID(state, id) {
    state.conversationId = id;
  },

  ADD_MESSAGE(state, message) {
    state.messages.push(message);
  },
  CLEAR_MESSAGES(state) {
    state.messages = [];
  },
  SET_LAST_SEARCH_QUERY(state, query) {
    state.lastSearchQuery = query
  },

  SET_REFINEMENTS(state, refinements) {
    state.refinements = refinements || [];
  },

  SET_SERCH_REFINEMENTS(state, refinements) {
    state.searchRefinements = refinements || [];
  },
  
  SET_PRODUCTS(state, products) {
    state.products = products || [];
  },
}